export const estimatePracticeDurationMinutes = (
  questionCount: number,
): number | undefined => {
  if (!Number.isFinite(questionCount) || questionCount <= 0) {
    return undefined;
  }

  return Math.max(1, Math.round(questionCount * 2));
};

export const splitDurationMinutes = (totalMinutes: number) => {
  const roundedMinutes = Math.max(0, Math.round(totalMinutes));

  return {
    hours: Math.floor(roundedMinutes / 60),
    minutes: roundedMinutes % 60,
  };
};
